import createClient from 'openapi-fetch';
import type { paths } from './Schema';

const OpenAPI = createClient<paths>({
  baseUrl: process.env.REACT_APP_API_BASE_URI,
});

export default OpenAPI;
